<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-66">
            <form ref="category_add" @submit.prevent="addDocumentType">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>add</md-icon>
                        </div>
                        <h4 class="title">{{ this.label }}</h4>
                    </md-card-header>
                    <form-content :document-type="documentType" :errors="errors"></form-content>
                    <md-card-actions md-alignment="left">
                        <md-button type="submit" class="md-success">
                            Enregistrer
                        </md-button>
                        <md-button class="md-warning"
                                   @click="goBack">
                            Retour
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </div>
    </div>
</template>

<script>
import FormContent from "@/pages/Documents/Type/components/FormContent";

export default {
    name: "TypeAdd",
    components: { FormContent },
    data() {
        return {
            documentType: {
                name: '',
                isActive: true,
                order: 0,
                parentId: null
            },
            errors: [],
        }
    },
    methods: {
        async addDocumentType() {
            this.documentType.name = this.documentType.name.toUpperCase()
            try {
                this.errors = null
                await this.$store.dispatch('documents/addDocumentType', this.documentType)
                await this.$store.dispatch("alerts/success", "Catégorie ajoutée");
                this.$router.go(-1);
            } catch (e) {
                this.errors = e.response.data.errors
            }
        },
        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped>

</style>
